import { render, staticRenderFns } from "./audio-block.vue?vue&type=template&id=2594e160&scoped=true&"
import script from "./audio-block.vue?vue&type=script&lang=ts&"
export * from "./audio-block.vue?vue&type=script&lang=ts&"
import style0 from "./audio-block.vue?vue&type=style&index=0&id=2594e160&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594e160",
  null
  
)

export default component.exports